import { images } from '../constants'; 

const cars = [
    {
        id: 1,
        dealerId: 1,
        image: images.car1Gallery1,
        price: 40,
        condition: 'New',
        content: 'The Toyota Camry is a stylish and reliable midsize sedan designed for everyday comfort and performance. With its smooth ride, fuel efficiency, and advanced safety features, it provides a perfect balance of practicality and driving pleasure.',
        gallery: {
            image1: images.car1Gallery1,
            image2: images.car1Gallery2,
            image3: images.car1Gallery3,
            image4: images.car1Gallery4,
        },
        details: {
            year: 2020,
            carMake: 'Toyota',
            carModel: 'Camry',
            carType: 'Sedan',
            passengers: '5 people',
            fuelType: 'Petrol',
            mileage: '28 MPG (City)',
            engine: '2.5L Inline-4',
            transmission: 'Automatic',
            horsepower: '203 HP',
            topSpeed: '135 mph',
            drivetrain: 'Front-Wheel',
        },
        description: 'The Toyota Camry stands as a symbol of reliability and modern engineering. Equipped with a powerful yet fuel-efficient 2.5L engine, it delivers 203 horsepower while maintaining excellent fuel economy. Its spacious cabin, intuitive technology, and smooth handling make it a top choice for daily commutes and long-distance drives. Whether navigating busy streets or cruising on the highway, the Camry provides a refined and comfortable experience for every journey.',
        features: {
            performance: [
                '203 Horsepower',
                '8-Speed Automatic Transmission',
                'Front-Wheel Drive',
                'Sport-Tuned Suspension (XSE Model)',
                'Excellent Fuel Efficiency',
            ],
            comfort: [
                'Leather-Trimmed Seats',
                'Power-Adjustable Driver’s Seat',
                'Dual-Zone Automatic Climate Control',
                'Spacious Cabin with Premium Materials',
                'Noise-Reducing Windshield & Windows',
            ],
            technology: [
                'Apple CarPlay & Android Auto',
                'Toyota Safety Sense 2.5+',
                '8-Inch Touchscreen Infotainment',
                'Wireless Smartphone Charging',
                'Bluetooth Connectivity',
            ],
            safety: [
                'Pre-Collision System with Pedestrian Detection',
                'Lane Departure Alert with Steering Assist',
                'Adaptive Cruise Control',
                'Blind Spot Monitor',
                'Ten Airbag System',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car1Review1,
                name: 'James Reynolds',
                date: 'Jan 10th, 2023',
                rating: 4.8,
                content: 'The Camry is incredibly smooth and comfortable. Perfect for long drives and city commutes alike!',
            },
            {
                id: 2,
                image: images.car1Review2,
                name: 'Olivia Martinez',
                date: 'June 22nd, 2023',
                rating: 4.5,
                content: 'A great sedan with top-notch safety features and a quiet, spacious cabin. Highly recommend it!',
            },
        ]
    },
    {
        id: 2,
        dealerId: 2,
        image: images.car2Gallery1,
        price: 55,
        condition: 'old',
        content: 'The BMW Z4 is a premium roadster that blends luxury with exhilarating performance. With its sleek design, powerful engine, and advanced technology, the Z4 delivers a dynamic and engaging driving experience on every road.',
        gallery: {
            image1: images.car2Gallery1,
            image2: images.car2Gallery2,
            image3: images.car2Gallery3,
            image4: images.car2Gallery4,
        },
        details: {
            year: 2021,
            carMake: 'BMW',
            carModel: 'Z4',
            carType: 'Convertible',
            passengers: '2 people',
            fuelType: 'Petrol',
            mileage: '25 MPG (City)',
            engine: '3.0L Turbocharged Inline-6',
            transmission: 'Automatic',
            horsepower: '382 HP',
            topSpeed: '155 mph',
            drivetrain: 'Rear-Wheel',
        },
        description: 'The BMW Z4 is a modern interpretation of the classic roadster, designed for thrill-seekers who demand both style and performance. Equipped with a 3.0L turbocharged inline-6 engine producing 382 horsepower, it accelerates with precision while delivering a smooth yet aggressive ride. The Z4’s finely tuned suspension, aerodynamic body, and driver-focused cockpit make it the perfect sports car for both city streets and open highways.',
        features: {
            performance: [
                '382 Horsepower',
                '8-Speed Automatic Transmission',
                'Rear-Wheel Drive',
                'Adaptive M Suspension',
                'Sport Exhaust System',
            ],
            comfort: [
                'M Sport Seats with Heating',
                'Leather-Wrapped Steering Wheel',
                'Dual-Zone Automatic Climate Control',
                'Power Adjustable Seats',
                'Convertible Soft Top',
            ],
            technology: [
                'BMW iDrive 7.0 System',
                'Apple CarPlay & Android Auto',
                'Harman Kardon Premium Audio',
                'Live Cockpit Professional',
                'Wireless Smartphone Charging',
            ],
            safety: [
                'Active Blind Spot Detection',
                'Lane Departure Warning',
                'Rearview Camera with Parking Sensors',
                'Dynamic Stability Control',
                'Airbag System with Side-Impact Protection',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car2Review1,
                name: 'Daniel Foster',
                date: 'Mar 8th, 2023',
                rating: 4.9,
                content: 'The Z4 is an absolute joy to drive! Smooth handling, powerful acceleration, and pure luxury.',
            },
            {
                id: 2,
                image: images.car2Review2,
                name: 'Sophia Williams',
                date: 'July 15th, 2023',
                rating: 4.7,
                content: 'Incredible design, powerful engine, and top-tier tech. A convertible that truly stands out!',
            },
        ]
    },
    {
        id: 3,
        dealerId: 3,
        image: images.car3Gallery1,
        price: 65,
        condition: 'Certified Pre-Owned',
        content: 'The BMW X5 is a luxury midsize SUV that offers a perfect blend of power, sophistication, and cutting-edge technology. With its spacious interior, dynamic performance, and advanced safety features, the X5 redefines what an SUV can be.',
        gallery: {
            image1: images.car3Gallery1,
            image2: images.car3Gallery2,
            image3: images.car3Gallery3,
            image4: images.car3Gallery4,
        },
        details: {
            year: 2022,
            carMake: 'BMW',
            carModel: 'X5',
            carType: 'SUV',
            passengers: '5 people',
            fuelType: 'Petrol',
            mileage: '23 MPG (City)',
            engine: '3.0L Turbocharged Inline-6',
            transmission: 'Automatic',
            horsepower: '375 HP',
            topSpeed: '155 mph',
            drivetrain: 'All-Wheel Drive',
        },
        description: 'The BMW X5 is built to deliver both luxury and power. Featuring a refined 3.0L turbocharged inline-6 engine with 375 horsepower, the X5 provides thrilling acceleration while maintaining impressive efficiency. Its elegant interior, loaded with premium materials and intuitive technology, ensures every drive is as comfortable as it is exciting. With BMW’s intelligent xDrive system, the X5 confidently handles any road conditions, making it the perfect choice for both city commutes and adventurous getaways.',
        features: {
            performance: [
                '375 Horsepower',
                '8-Speed Automatic Transmission',
                'xDrive All-Wheel Drive',
                'Adaptive Air Suspension',
                'Sport Mode for Enhanced Performance',
            ],
            comfort: [
                'Vernasca Leather Upholstery',
                'Heated & Ventilated Front Seats',
                'Panoramic Moonroof',
                '4-Zone Automatic Climate Control',
                'Power Adjustable Seats with Memory Function',
            ],
            technology: [
                'BMW iDrive 8.0 System',
                'Apple CarPlay & Android Auto',
                'Harman Kardon Surround Sound System',
                'Live Cockpit Professional with 12.3-inch Display',
                'Wireless Smartphone Charging',
            ],
            safety: [
                'Adaptive Cruise Control with Stop & Go',
                'Lane Keeping Assist',
                '360-Degree Camera System',
                'Blind Spot Detection',
                'Front & Rear Parking Sensors',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car3Review1,
                name: 'Michael Thompson',
                date: 'Feb 20th, 2023',
                rating: 4.9,
                content: 'The BMW X5 is the ultimate balance of luxury and performance. Smooth ride, great features, and a stunning interior!',
            },
            {
                id: 2,
                image: images.car3Review2,
                name: 'Emily Carter',
                date: 'Aug 3rd, 2023',
                rating: 4.8,
                content: 'Absolutely love my X5! It’s spacious, powerful, and filled with the latest technology. Worth every penny!',
            },
        ]
    },
    {
        id: 4,
        dealerId: 4,
        image: images.car4Gallery1, 
        price: 30,
        condition: 'New',
        content: 'The Volkswagen Golf is a versatile and stylish hatchback that combines efficiency, performance, and modern technology. With its sleek design, spacious interior, and dynamic driving experience, the Golf is the perfect companion for city commutes and long drives alike.',
        gallery: {
            image1: images.car4Gallery1,
            image2: images.car4Gallery2,
            image3: images.car4Gallery3,
            image4: images.car4Gallery4,
        },
        details: {
            year: 2023,
            carMake: 'Volkswagen',
            carModel: 'Golf',
            carType: 'Hatchback',
            passengers: '5 people',
            fuelType: 'Petrol',
            mileage: '29 MPG (City)',
            engine: '1.5L Turbocharged Inline-4',
            transmission: 'Automatic',
            horsepower: '158 HP',
            topSpeed: '130 mph',
            drivetrain: 'Front-Wheel Drive',
        },
        description: 'The Volkswagen Golf is the perfect balance of practicality and fun. Powered by a 1.5L turbocharged engine delivering 158 horsepower, it offers a smooth and efficient drive. Inside, the Golf features a premium cabin with intuitive technology, including a touchscreen infotainment system and driver-assistance features. Its refined handling, spacious design, and legendary reliability make it a top choice for drivers who want both efficiency and enjoyment on the road.',
        features: {
            performance: [
                '158 Horsepower',
                '7-Speed DSG Automatic Transmission',
                'Turbocharged Engine for Better Efficiency',
                'Precise Steering & Agile Handling',
                'Selectable Drive Modes',
            ],
            comfort: [
                'Premium Cloth or Leatherette Seats',
                'Heated Front Seats',
                'Spacious Cabin with Ample Legroom',
                'Dual-Zone Automatic Climate Control',
                'Adjustable Steering Wheel with Mounted Controls',
            ],
            technology: [
                '8.25-inch Touchscreen Infotainment System',
                'Apple CarPlay & Android Auto',
                'Volkswagen Digital Cockpit',
                'Wireless Charging Pad',
                'Bluetooth Connectivity with Voice Control',
            ],
            safety: [
                'Adaptive Cruise Control',
                'Lane Keeping Assist',
                'Rearview Camera System',
                'Blind Spot Monitoring',
                'Automatic Emergency Braking',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car4Review1,
                name: 'Daniel Peterson',
                date: 'March 12th, 2023',
                rating: 4.6,
                content: 'The Golf is an amazing hatchback! Smooth ride, great fuel efficiency, and packed with modern tech. Perfect for daily driving!',
            },
            {
                id: 2,
                image: images.car4Review2,
                name: 'Jessica Turner',
                date: 'Sept 8th, 2023',
                rating: 4.5,
                content: 'I love my Volkswagen Golf! It’s compact yet spacious, drives beautifully, and has excellent features for the price.',
            },
        ]
    },
    {
        id: 5,
        dealerId: 5,
        image: images.car5Gallery1, 
        price: 115,
        condition: 'Old',
        content: 'The Nissan GT-R is an iconic supercar that blends cutting-edge technology with breathtaking performance. With its powerful twin-turbo V6 engine, all-wheel drive system, and aerodynamic design, the GT-R delivers an adrenaline-pumping driving experience like no other.',
        gallery: {
            image1: images.car5Gallery1,
            image2: images.car5Gallery2,
            image3: images.car5Gallery3,
            image4: images.car5Gallery4,
        },
        details: {
            year: 2024,
            carMake: 'Nissan',
            carModel: 'GT-R',
            carType: 'Sports Car',
            passengers: '4 people',
            fuelType: 'Petrol',
            mileage: '16 MPG (City)',
            engine: '3.8L Twin-Turbo V6',
            transmission: '6-Speed Dual-Clutch Automatic',
            horsepower: '565 HP',
            topSpeed: '205 mph',
            drivetrain: 'All-Wheel Drive',
        },
        description: 'The Nissan GT-R is a masterpiece of engineering, combining raw power with precision handling. Powered by a hand-assembled 3.8L twin-turbo V6 engine producing 565 horsepower, it accelerates from 0-60 mph in under 3 seconds. The GT-R’s aerodynamic body, adaptive suspension, and intelligent all-wheel drive system ensure maximum stability and performance. Whether on the track or the open road, the GT-R delivers a driving experience that’s truly exhilarating.',
        features: {
            performance: [
                '565 Horsepower Twin-Turbo V6',
                '0-60 mph in Under 3 Seconds',
                'Advanced All-Wheel Drive System',
                '6-Speed Dual-Clutch Transmission',
                'Brembo High-Performance Brakes',
            ],
            comfort: [
                'Premium Leather & Alcantara Interior',
                'Heated Front Sport Seats',
                'Dual-Zone Climate Control',
                'Driver-Focused Cockpit with Paddle Shifters',
                'Customizable Digital Display',
            ],
            technology: [
                '8-inch Touchscreen Infotainment System',
                'Apple CarPlay Integration',
                'Premium Bose Audio System',
                'Built-In Navigation System',
                'NissanConnect Services',
            ],
            safety: [
                'Advanced Airbag System',
                'Rearview Camera with Parking Sensors',
                'Blind Spot Monitoring',
                'Intelligent Forward Collision Warning',
                'Traction & Stability Control',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car5Review1,
                name: 'James Miller',
                date: 'April 20th, 2023',
                rating: 4.9,
                content: 'The GT-R is an absolute beast! Unmatched acceleration, insane handling, and a design that turns heads everywhere.',
            },
            {
                id: 2,
                image: images.car5Review2,
                name: 'Sophia Ramirez',
                date: 'July 15th, 2023',
                rating: 4.8,
                content: 'Driving the GT-R is an experience like no other. It’s aggressive, powerful, and surprisingly comfortable for a supercar.',
            },
        ]
    },
    {
        id: 6,
        dealerId: 6,
        image: images.car6Gallery1, 
        price: 45,
        condition: 'Certified Pre-Owned',
        content: 'The Kia Carnival redefines the modern minivan with a bold design, spacious interior, and cutting-edge technology. Offering premium comfort and versatile seating, the Carnival is the perfect blend of style and practicality for families and long road trips.',
        gallery: {
            image1: images.car6Gallery1,
            image2: images.car6Gallery2,
            image3: images.car6Gallery3,
            image4: images.car6Gallery4,
        },
        details: {
            year: 2025,
            carMake: 'Kia',
            carModel: 'Carnival',
            carType: 'Minivan',
            passengers: '7-8 people',
            fuelType: 'Petrol',
            mileage: '19 MPG (City)',
            engine: '3.5L V6',
            transmission: '8-Speed Automatic',
            horsepower: '290 HP',
            topSpeed: '120 mph',
            drivetrain: 'Front-Wheel Drive',
        },
        description: 'The Kia Carnival is the ultimate family vehicle, combining SUV-inspired styling with the practicality of a minivan. Under the hood, a 3.5L V6 engine delivers 290 horsepower, ensuring a smooth and powerful drive. Inside, the Carnival offers luxurious seating for up to 8 passengers, a suite of smart tech features, and a spacious cargo area. Whether for daily commutes or weekend adventures, the Carnival provides comfort, convenience, and style in one complete package.',
        features: {
            performance: [
                '290 Horsepower V6 Engine',
                '8-Speed Automatic Transmission',
                'Smooth & Quiet Ride',
                'Advanced Suspension System',
                'Front-Wheel Drive Stability',
            ],
            comfort: [
                'Premium Leather & Heated Seats',
                'Tri-Zone Climate Control',
                'Second-Row VIP Lounge Seats',
                'Power Sliding Doors',
                'Panoramic Sunroof',
            ],
            technology: [
                '12.3-inch Touchscreen Infotainment System',
                'Apple CarPlay & Android Auto',
                'Bose Premium Sound System',
                'Wireless Charging Pad',
                'Rear-Seat Entertainment System',
            ],
            safety: [
                '360-Degree Surround View Camera',
                'Blind Spot Monitoring',
                'Lane Keeping Assist',
                'Forward Collision-Avoidance Assist',
                'Rear Cross-Traffic Alert',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car6Review1,
                name: 'Michael Johnson',
                date: 'March 10th, 2023',
                rating: 4.8,
                content: 'The Carnival is a game-changer! Spacious, luxurious, and packed with tech. Perfect for family road trips!',
            },
            {
                id: 2,
                image: images.car6Review2,
                name: 'Emily Carter',
                date: 'June 25th, 2023',
                rating: 4.6,
                content: 'Love how comfortable and stylish the Carnival is. The VIP lounge seats are amazing for long drives!',
            },
        ]
    },
    {
        id: 7,
        dealerId: 1,
        image: images.car7Gallery1,
        price: 55,
        condition: 'New',
        content: 'The Ford Mustang is an iconic American muscle car that delivers raw power, aggressive styling, and thrilling performance. With its legendary design and advanced technology, the Mustang is built to dominate the road and provide an unforgettable driving experience.',
        gallery: {
            image1: images.car7Gallery1,
            image2: images.car7Gallery2,
            image3: images.car7Gallery3,
            image4: images.car7Gallery4,
        },
        details: {
            year: 2020,
            carMake: 'Ford',
            carModel: 'Mustang',
            carType: 'Coupe',
            passengers: '4 people',
            fuelType: 'Petrol',
            mileage: '15 MPG (City)',
            engine: '5.0L V8',
            transmission: '10-Speed Automatic',
            horsepower: '450 HP',
            topSpeed: '155 mph',
            drivetrain: 'Rear-Wheel Drive',
        },
        description: 'The Ford Mustang represents the perfect blend of performance, style, and innovation. Powered by a 5.0L V8 engine producing 450 horsepower, it delivers a heart-pounding drive with an unmistakable roar. Featuring an aggressive stance, aerodynamic body lines, and a modern cockpit filled with advanced tech, the Mustang is designed for true driving enthusiasts. Whether cruising through the city or hitting the open road, the Mustang offers an unmatched driving experience.',
        features: {
            performance: [
                '450 Horsepower V8 Engine',
                '10-Speed Automatic Transmission',
                'Rear-Wheel Drive for Ultimate Control',
                'Selectable Drive Modes',
                'Sport-Tuned Suspension',
            ],
            comfort: [
                'Recaro Leather Seats',
                'Dual-Zone Climate Control',
                'Heated & Ventilated Front Seats',
                'Premium Interior Finishes',
                'Ambient Interior Lighting',
            ],
            technology: [
                '12-inch Digital Instrument Cluster',
                'SYNC 4 Infotainment System',
                'Apple CarPlay & Android Auto',
                'Bang & Olufsen Sound System',
                'Wireless Charging Pad',
            ],
            safety: [
                'Ford Co-Pilot360 Safety Suite',
                'Lane-Keeping Assist',
                'Adaptive Cruise Control',
                'Blind Spot Monitoring',
                'Rear-View Camera with Parking Assist',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car7Review1,
                name: 'James Peterson',
                date: 'April 18th, 2023',
                rating: 4.9,
                content: 'Absolutely love my Mustang! The power, the sound, and the design make it a dream car for any muscle car fan.',
            },
            {
                id: 2,
                image: images.car7Review2,
                name: 'Sarah Mitchell',
                date: 'July 12th, 2023',
                rating: 4.7,
                content: 'The Mustang is a beast! It handles like a dream and turns heads everywhere I go. Best car I’ve ever owned!',
            },
        ]
    },
    {
        id: 8,
        dealerId: 2,
        image: images.car8Gallery1,
        price: 48,
        condition: 'Old',
        content: 'The Chevrolet Silverado 1500 is a powerful and versatile full-size pickup truck built for strength, capability, and advanced technology. Whether hauling heavy loads or navigating off-road terrain, the Silverado 1500 is engineered to handle any challenge with ease.',
        gallery: {
            image1: images.car8Gallery1,
            image2: images.car8Gallery2,
            image3: images.car8Gallery3,
            image4: images.car8Gallery4,
        },
        details: {
            year: 2021,
            carMake: 'Chevrolet',
            carModel: 'Silverado 1500',
            carType: 'Truck',
            passengers: '5 people',
            fuelType: 'Petrol / Diesel',
            mileage: '20 MPG (City)',
            engine: '5.3L V8',
            transmission: '10-Speed Automatic',
            horsepower: '355 HP',
            topSpeed: '120 mph',
            drivetrain: 'Four-Wheel Drive',
        },
        description: 'The Chevrolet Silverado 1500 is a rugged and reliable truck designed for both work and play. Featuring a 5.3L V8 engine with 355 horsepower, it delivers impressive towing capability while maintaining smooth on-road performance. With a spacious and high-tech interior, advanced trailering features, and durable construction, the Silverado is built to handle everything from job sites to weekend adventures with confidence.',
        features: {
            performance: [
                '355 Horsepower V8 Engine',
                '10-Speed Automatic Transmission',
                'Available Duramax Diesel Option',
                'Off-Road Suspension with Rancho Shocks',
                'Integrated Trailer Brake Controller',
            ],
            comfort: [
                'Leather-Appointed Seating',
                'Heated & Ventilated Front Seats',
                'Dual-Zone Automatic Climate Control',
                'Spacious Crew Cab Design',
                'Power-Adjustable Driver Seat',
            ],
            technology: [
                '13.4-inch Infotainment Touchscreen',
                'Wireless Apple CarPlay & Android Auto',
                'Bose Premium Sound System',
                'Head-Up Display',
                '360-Degree Camera System',
            ],
            safety: [
                'Chevrolet Safety Assist Suite',
                'Forward Collision Alert',
                'Lane Keep Assist with Lane Departure Warning',
                'Rear Cross Traffic Alert',
                'Adaptive Cruise Control',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car8Review1,
                name: 'Michael Roberts',
                date: 'March 22nd, 2023',
                rating: 4.8,
                content: 'The Silverado is an absolute workhorse! It tows like a beast and feels super solid on the road. Highly recommend!',
            },
            {
                id: 2,
                image: images.car8Review2,
                name: 'Emma Johnson',
                date: 'June 9th, 2023',
                rating: 4.6,
                content: 'Super comfortable and packed with great tech. The Silverado 1500 is a perfect mix of power and luxury!',
            },
        ]
    },
    {
        id: 9,
        dealerId: 3,
        image: images.car9Gallery1, 
        price: 32,
        condition: 'Certified Pre-Owned',
        content: 'The Honda Accord is a sophisticated and reliable midsize sedan that blends performance, efficiency, and advanced technology. With a stylish design, spacious interior, and smooth ride, it’s the perfect choice for both daily commutes and long road trips.',
        gallery: {
            image1: images.car9Gallery1,
            image2: images.car9Gallery2,
            image3: images.car9Gallery3,
            image4: images.car9Gallery4,
        },
        details: {
            year: 2022,
            carMake: 'Honda',
            carModel: 'Accord',
            carType: 'Sedan',
            passengers: '5 people',
            fuelType: 'Petrol / Hybrid',
            mileage: '30 MPG (City)',
            engine: '1.5L Turbocharged Inline-4',
            transmission: 'CVT Automatic',
            horsepower: '192 HP',
            topSpeed: '126 mph',
            drivetrain: 'Front-Wheel Drive',
        },
        description: 'The Honda Accord is designed for those who value efficiency, comfort, and cutting-edge technology. Powered by a 1.5L turbocharged engine delivering 192 horsepower, it provides a responsive and fuel-efficient drive. The Accord’s spacious interior, advanced driver-assist features, and sleek exterior make it an outstanding choice for drivers who seek both practicality and style.',
        features: {
            performance: [
                '192 Horsepower Turbocharged Engine',
                'Continuously Variable Transmission (CVT)',
                'Eco Assist™ System',
                'MacPherson Strut Front Suspension',
                'Sport Mode for Enhanced Driving Experience',
            ],
            comfort: [
                'Leather-Trimmed Interior',
                'Heated & Ventilated Front Seats',
                'Dual-Zone Automatic Climate Control',
                'Spacious Rear Legroom',
                'Power-Adjustable Driver’s Seat',
            ],
            technology: [
                '12.3-inch Infotainment Touchscreen',
                'Wireless Apple CarPlay & Android Auto',
                'Premium Audio System',
                'Head-Up Display',
                'Wireless Charging Pad',
            ],
            safety: [
                'Honda Sensing® Safety Suite',
                'Adaptive Cruise Control',
                'Collision Mitigation Braking System',
                'Lane Keeping Assist System',
                'Traffic Sign Recognition',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car9Review1,
                name: 'James Peterson',
                date: 'April 10th, 2023',
                rating: 4.7,
                content: 'The Accord is an incredible sedan! Smooth ride, great fuel economy, and packed with advanced features. Highly recommend!',
            },
            {
                id: 2,
                image: images.car9Review2,
                name: 'Sarah Lee',
                date: 'July 15th, 2023',
                rating: 4.5,
                content: 'Spacious, stylish, and tech-savvy. The Accord is perfect for my daily commute and long drives. Love it!',
            },
        ]
    },
    {
        id: 10,
        dealerId: 4,
        image: images.car10Gallery1,
        price: 130,
        condition: 'New',
        content: 'The Porsche 911 Cabriolet is an icon of performance and luxury. With its timeless design, open-top driving experience, and exhilarating power, this convertible delivers an unmatched driving thrill on both city streets and winding highways.',
        gallery: {
            image1: images.car10Gallery1,
            image2: images.car10Gallery2,
            image3: images.car10Gallery3,
            image4: images.car10Gallery4,
        },
        details: {
            year: 2023,
            carMake: 'Porsche',
            carModel: '911 Cabriolet',
            carType: 'Convertible',
            passengers: '4 people',
            fuelType: 'Petrol',
            mileage: '18 MPG (City)',
            engine: '3.0L Twin-Turbo Flat-6',
            transmission: '8-Speed PDK Automatic',
            horsepower: '379 HP',
            topSpeed: '182 mph',
            drivetrain: 'Rear-Wheel Drive / All-Wheel Drive',
        },
        description: 'The Porsche 911 Cabriolet embodies pure driving pleasure with a perfect blend of power, precision, and open-air excitement. Its 3.0L twin-turbocharged flat-six engine delivers 379 horsepower, offering breathtaking acceleration and precision handling. The sophisticated soft-top roof retracts in just seconds, transforming every drive into a dynamic experience filled with freedom and speed.',
        features: {
            performance: [
                '379 Horsepower Twin-Turbo Engine',
                '8-Speed PDK Automatic Transmission',
                'Active Suspension Management (PASM)',
                'Rear-Axle Steering for Enhanced Agility',
                'Launch Control for Maximum Acceleration',
            ],
            comfort: [
                'Premium Leather & Alcantara Interior',
                '14-Way Power Sport Seats',
                'Dual-Zone Climate Control',
                'Heated & Ventilated Seats',
                'Retractable Soft-Top Roof',
            ],
            technology: [
                '10.9-inch Touchscreen Infotainment',
                'Wireless Apple CarPlay & Android Auto',
                'Bose Surround Sound System',
                'Porsche Communication Management (PCM)',
                'Advanced Navigation with Real-Time Traffic',
            ],
            safety: [
                'Porsche Stability Management (PSM)',
                'Adaptive Cruise Control',
                'Lane Keep Assist with Traffic Sign Recognition',
                'Surround View Camera System',
                'Front and Rear Parking Sensors',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car10Review1,
                name: 'Michael Carter',
                date: 'May 22nd, 2023',
                rating: 4.9,
                content: 'The 911 Cabriolet is pure perfection! Open-top driving, incredible handling, and the unmistakable Porsche performance. Love every second behind the wheel!',
            },
            {
                id: 2,
                image: images.car10Review2,
                name: 'Sophia Williams',
                date: 'August 8th, 2023',
                rating: 4.8,
                content: 'Luxury, speed, and a stunning design. The Porsche 911 Cabriolet is the best convertible sports car I’ve ever owned!',
            },
        ]
    },
    {
        id: 11,
        dealerId: 5,
        image: images.car11Gallery1,
        price: 55,
        condition: 'Old',
        content: 'The Jeep Grand Cherokee is a perfect blend of rugged capability and refined luxury. Designed for adventure and comfort, this SUV offers powerful performance, advanced technology, and premium features to conquer both city streets and off-road trails.',
        gallery: {
            image1: images.car11Gallery1,
            image2: images.car11Gallery2,
            image3: images.car11Gallery3,
            image4: images.car11Gallery4,
        },
        details: {
            year: 2024,
            carMake: 'Jeep',
            carModel: 'Grand Cherokee',
            carType: 'SUV',
            passengers: '5-7 people',
            fuelType: 'Petrol / Hybrid',
            mileage: '19 MPG (City)',
            engine: '3.6L V6 / 5.7L V8 / Plug-in Hybrid',
            transmission: '8-Speed Automatic',
            horsepower: '293 - 357 HP',
            topSpeed: '120 mph',
            drivetrain: 'Rear-Wheel Drive / 4x4',
        },
        description: 'The Jeep Grand Cherokee is built to tackle any terrain with confidence while delivering a premium driving experience. Its powerful engine options, advanced 4x4 capabilities, and sophisticated interior make it a versatile SUV for both urban commutes and off-road adventures. With a spacious cabin, cutting-edge technology, and top-tier safety features, the Grand Cherokee is a top choice for those who demand performance and luxury in one package.',
        features: {
            performance: [
                'Multiple Engine Options (V6, V8, Hybrid)',
                'Quadra-Trac 4x4 System',
                'Adaptive Air Suspension',
                'Selectable Drive Modes for Various Terrains',
                'Towing Capacity up to 7,200 lbs',
            ],
            comfort: [
                'Premium Leather Upholstery',
                'Heated & Ventilated Front Seats',
                'Panoramic Sunroof',
                'Three-Zone Climate Control',
                'Power Adjustable Front Seats',
            ],
            technology: [
                '10.1-inch Touchscreen Infotainment',
                'Apple CarPlay & Android Auto',
                '19-Speaker McIntosh Audio System',
                'Heads-Up Display',
                'Wireless Charging Pad',
            ],
            safety: [
                'Adaptive Cruise Control with Stop & Go',
                'Lane Departure Warning & Lane Keep Assist',
                'Blind Spot Monitoring',
                'Surround View Camera System',
                'Automatic Emergency Braking',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car11Review1,
                name: 'James Anderson',
                date: 'June 15th, 2023',
                rating: 4.8,
                content: 'The Grand Cherokee is the perfect mix of off-road power and luxury. Comfortable ride, spacious cabin, and outstanding technology!',
            },
            {
                id: 2,
                image: images.car11Review2,
                name: 'Olivia Martinez',
                date: 'September 3rd, 2023',
                rating: 4.7,
                content: 'An excellent SUV with great features and performance. I love the hybrid option for fuel efficiency without sacrificing power!',
            },
        ]
    },
    {
        id: 12,
        dealerId: 6,
        image: images.car12Gallery1,
        price: 30,
        condition: 'Certified Pre-Owned',
        content: 'The Hyundai i30 is a stylish and practical hatchback designed for modern driving. With its fuel-efficient engine, advanced technology, and spacious interior, it offers a comfortable and enjoyable ride for both city commuting and long-distance travel.',
        gallery: {
            image1: images.car12Gallery1,
            image2: images.car12Gallery2,
            image3: images.car12Gallery3,
            image4: images.car12Gallery4,
        },
        details: {
            year: 2025,
            carMake: 'Hyundai',
            carModel: 'i30',
            carType: 'Hatchback',
            passengers: '5 people',
            fuelType: 'Petrol / Diesel',
            mileage: '34 MPG (City)',
            engine: '1.0L Turbo / 1.5L Turbo / 2.0L N Line',
            transmission: '6-Speed Manual / 7-Speed Automatic',
            horsepower: '118 - 276 HP',
            topSpeed: '155 mph',
            drivetrain: 'Front-Wheel Drive',
        },
        description: 'The Hyundai i30 combines sleek design with advanced technology and everyday practicality. Its efficient engine options, smooth handling, and modern infotainment system make it a great choice for drivers who want a balance of performance and economy. With a well-crafted interior, generous cargo space, and top safety features, the i30 is perfect for families and urban explorers alike.',
        features: {
            performance: [
                'Turbocharged Engine Options',
                'Sporty Suspension on N Line Models',
                'Selectable Driving Modes',
                'Fuel-Efficient Powertrain',
                'Quick Acceleration',
            ],
            comfort: [
                'Premium Fabric or Leather Upholstery',
                'Heated & Ventilated Front Seats',
                'Dual-Zone Climate Control',
                'Adjustable Steering Column',
                'Spacious Cabin with Foldable Rear Seats',
            ],
            technology: [
                '10.25-inch Touchscreen Infotainment',
                'Apple CarPlay & Android Auto',
                'Bose Premium Audio System',
                'Wireless Charging Pad',
                'Digital Instrument Cluster',
            ],
            safety: [
                'Lane Keeping Assist',
                'Adaptive Cruise Control',
                'Blind Spot Collision Warning',
                'Rear Cross-Traffic Alert',
                'Autonomous Emergency Braking',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car12Review1,
                name: 'Michael Johnson',
                date: 'April 22nd, 2023',
                rating: 4.6,
                content: 'The Hyundai i30 is a great all-rounder! It’s efficient, comfortable, and packed with features. Perfect for daily driving!',
            },
            {
                id: 2,
                image: images.car12Review2,
                name: 'Emma Wilson',
                date: 'August 10th, 2023',
                rating: 4.5,
                content: 'Love my i30! The interior is well-designed, and the infotainment system is super intuitive. A great car for city and highway driving!',
            },
        ]
    },
    {
        id: 13,
        dealerId: 1,
        image: images.car13Gallery1,
        price: 70,
        condition: 'New',
        content: 'The Chevrolet Corvette is an iconic American sports car that blends breathtaking performance with sleek, aggressive styling. Equipped with a powerful V8 engine and precision-tuned handling, it delivers an exhilarating driving experience on both the track and the road.',
        gallery: {
            image1: images.car13Gallery1,
            image2: images.car13Gallery2,
            image3: images.car13Gallery3,
            image4: images.car13Gallery4,
        },
        details: {
            year: 2020,
            carMake: 'Chevrolet',
            carModel: 'Corvette',
            carType: 'Sports Car',
            passengers: '2 people',
            fuelType: 'Petrol',
            mileage: '16 MPG (City)',
            engine: '6.2L V8 / 5.5L V8 (Z06)',
            transmission: '8-Speed Dual-Clutch',
            horsepower: '495 - 670 HP',
            topSpeed: '194 mph',
            drivetrain: 'Rear-Wheel Drive',
        },
        description: 'The Chevrolet Corvette is a legend in the sports car world, offering world-class performance at an unbeatable value. With a mid-engine design, high-revving V8, and razor-sharp handling, it provides an adrenaline-pumping ride every time you hit the accelerator. Whether cruising the highway or attacking corners, the Corvette delivers pure driving excitement.',
        features: {
            performance: [
                'Mid-Engine Design',
                'High-Performance V8 Engine',
                'Lightning-Fast 8-Speed Dual-Clutch Transmission',
                'Adaptive Magnetic Ride Control',
                'Track-Tuned Suspension',
            ],
            comfort: [
                'Premium Leather-Wrapped Interior',
                'Heated & Ventilated Sports Seats',
                'Dual-Zone Climate Control',
                'Flat-Bottom Steering Wheel',
                'Power Adjustable Seating',
            ],
            technology: [
                '12-inch Digital Instrument Cluster',
                'Bose Premium Audio System',
                'Apple CarPlay & Android Auto',
                'Performance Data Recorder',
                'Wireless Phone Charging',
            ],
            safety: [
                'Rear Cross-Traffic Alert',
                'Front & Rear Parking Sensors',
                'Blind Spot Monitoring',
                'Performance Traction Management',
                'Advanced Airbag System',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car13Review1,
                name: 'James Carter',
                date: 'March 15th, 2023',
                rating: 4.9,
                content: 'The Corvette is an absolute beast! The mid-engine setup gives it incredible balance, and the acceleration is mind-blowing.',
            },
            {
                id: 2,
                image: images.car13Review2,
                name: 'Sophia Martinez',
                date: 'June 30th, 2023',
                rating: 4.8,
                content: 'I love my Corvette! It’s a dream to drive, the interior is luxurious, and the performance is out of this world!',
            },
        ]
    },
    {
        id: 14,
        dealerId: 2,
        image: images.car14Gallery1,
        price: 40,
        condition: 'Old',
        content: 'The Toyota Sienna is a versatile and family-friendly minivan designed for comfort, efficiency, and practicality. With its spacious interior, hybrid powertrain, and advanced safety features, it’s the perfect choice for modern families on the go.',
        gallery: {
            image1: images.car14Gallery1,
            image2: images.car14Gallery2,
            image3: images.car14Gallery3,
            image4: images.car14Gallery4,
        },
        details: {
            year: 2021,
            carMake: 'Toyota',
            carModel: 'Sienna',
            carType: 'Minivan',
            passengers: '7-8 people',
            fuelType: 'Hybrid',
            mileage: '36 MPG (City)',
            engine: '2.5L 4-Cylinder Hybrid',
            transmission: 'eCVT',
            horsepower: '245 HP',
            topSpeed: '110 mph',
            drivetrain: 'Front-Wheel / All-Wheel Drive',
        },
        description: 'The Toyota Sienna is engineered for both efficiency and convenience, making it one of the best family vehicles on the market. With its hybrid engine, it offers impressive fuel economy while maintaining smooth and reliable performance. Packed with comfort-focused features and the latest technology, the Sienna ensures a pleasant ride for everyone.',
        features: {
            performance: [
                'Fuel-Efficient Hybrid Powertrain',
                'Available All-Wheel Drive',
                'Electronic Continuously Variable Transmission (eCVT)',
                'Sport-Tuned Suspension (XSE Trim)',
                'Smooth & Quiet Ride',
            ],
            comfort: [
                'Available 7- or 8-Passenger Seating',
                'Second-Row Captain’s Chairs',
                'Tri-Zone Climate Control',
                'Hands-Free Power Sliding Doors',
                'Premium Upholstery Options',
            ],
            technology: [
                '9-inch Touchscreen Infotainment System',
                'Apple CarPlay & Android Auto',
                'JBL Premium Audio System',
                'Wireless Smartphone Charging',
                'Rear Seat Entertainment System',
            ],
            safety: [
                'Toyota Safety Sense 2.0',
                'Blind Spot Monitoring',
                'Lane Keep Assist',
                'Adaptive Cruise Control',
                'Rear Cross-Traffic Alert',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car14Review1,
                name: 'Emily Johnson',
                date: 'April 10th, 2023',
                rating: 4.8,
                content: 'Our Sienna is the perfect family car! It’s spacious, comfortable, and gets great gas mileage thanks to the hybrid engine.',
            },
            {
                id: 2,
                image: images.car14Review2,
                name: 'Michael Thompson',
                date: 'July 8th, 2023',
                rating: 4.7,
                content: 'I love the technology and safety features in the Sienna. It makes long road trips so much easier and more enjoyable.',
            },
        ]
    },
    {
        id: 15,
        dealerId: 3,
        image: images.car15Gallery1,
        price: 75,
        condition: 'Certified Pre-Owned',
        content: 'The Mercedes-Benz Coupe is a perfect blend of luxury, power, and sophistication. With its sleek design, high-performance engine, and advanced technology, it delivers an exhilarating driving experience while maintaining elegance and comfort.',
        gallery: {
            image1: images.car15Gallery1,
            image2: images.car15Gallery2,
            image3: images.car15Gallery3,
            image4: images.car15Gallery4,
        },
        details: {
            year: 2022,
            carMake: 'Mercedes-Benz',
            carModel: 'Coupe',
            carType: 'Coupe',
            passengers: '4 people',
            fuelType: 'Petrol',
            mileage: '22 MPG (City)',
            engine: '3.0L Turbocharged Inline-6',
            transmission: '9-Speed Automatic',
            horsepower: '362 HP',
            topSpeed: '155 mph',
            drivetrain: 'Rear-Wheel / All-Wheel Drive',
        },
        description: 'The Mercedes-Benz Coupe stands as an icon of luxury and dynamic performance. From its sculpted lines to its cutting-edge features, this coupe is built for those who seek both prestige and power. With a refined interior, seamless connectivity, and superior handling, it offers an unmatched driving experience.',
        features: {
            performance: [
                'Turbocharged Inline-6 Engine',
                '9-Speed Automatic Transmission',
                'Available 4MATIC All-Wheel Drive',
                'Adaptive Damping Suspension',
                'Sport-Tuned Exhaust System',
            ],
            comfort: [
                'Nappa Leather Upholstery',
                'Heated & Ventilated Front Seats',
                'Dual-Zone Climate Control',
                'Panoramic Sunroof',
                'Multicolor Ambient Lighting',
            ],
            technology: [
                'MBUX Infotainment System',
                '12.3-inch Digital Instrument Cluster',
                'Apple CarPlay & Android Auto',
                'Burmester Surround Sound System',
                'Wireless Smartphone Charging',
            ],
            safety: [
                'Active Brake Assist',
                'Blind Spot Monitoring',
                'Lane Keeping Assist',
                'Adaptive Cruise Control',
                'Surround View Camera System',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car15Review1,
                name: 'Sophia Williams',
                date: 'March 5th, 2023',
                rating: 4.9,
                content: 'This car is pure luxury! The design is stunning, and the driving experience is smooth and powerful.',
            },
            {
                id: 2,
                image: images.car15Review2,
                name: 'James Carter',
                date: 'June 15th, 2023',
                rating: 4.8,
                content: 'Mercedes has nailed it again! The coupe offers a perfect balance of comfort and performance, making every drive enjoyable.',
            },
        ]
    },
    {
        id: 16,
        dealerId: 4,
        image: images.car16Gallery1,
        price: 38,
        condition: 'New',
        content: 'The Toyota Tacoma is a rugged and reliable midsize pickup truck built for adventure. With impressive off-road capability, durable construction, and modern tech features, it’s the perfect companion for both work and play.',
        gallery: {
            image1: images.car16Gallery1,
            image2: images.car16Gallery2,
            image3: images.car16Gallery3,
            image4: images.car16Gallery4,
        },
        details: {
            year: 2023,
            carMake: 'Toyota',
            carModel: 'Tacoma',
            carType: 'Truck',
            passengers: '5 people',
            fuelType: 'Petrol',
            mileage: '20 MPG (City)',
            engine: '3.5L V6',
            transmission: '6-Speed Automatic',
            horsepower: '278 HP',
            topSpeed: '115 mph',
            drivetrain: 'Rear-Wheel / 4WD',
        },
        description: 'The Toyota Tacoma is a legend in the world of midsize trucks. Designed to handle tough terrains and demanding jobs, it delivers exceptional reliability and performance. Whether you’re exploring the great outdoors or hauling heavy loads, the Tacoma is always ready for the challenge.',
        features: {
            performance: [
                '3.5L V6 Engine',
                'Available 4WD with Crawl Control',
                'Multi-Terrain Select System',
                'Bilstein Shocks (TRD Off-Road)',
                'Tow Package with Trailer Sway Control',
            ],
            comfort: [
                'Leather-Trimmed Seats',
                'Dual-Zone Climate Control',
                'Power-Adjustable Driver Seat',
                'Sunroof',
                'Heated Front Seats',
            ],
            technology: [
                '8-inch Touchscreen Infotainment System',
                'Apple CarPlay & Android Auto',
                'JBL Premium Audio System',
                'Wireless Charging Pad',
                'Navigation System',
            ],
            safety: [
                'Toyota Safety Sense (TSS-P)',
                'Pre-Collision System with Pedestrian Detection',
                'Lane Departure Alert',
                'Blind Spot Monitor',
                'Rear Cross-Traffic Alert',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car16Review1,
                name: 'Michael Anderson',
                date: 'March 12th, 2023',
                rating: 4.8,
                content: 'The Tacoma is built tough! I’ve taken it on multiple off-road trips, and it performs flawlessly every time.',
            },
            {
                id: 2,
                image: images.car16Review2,
                name: 'Jessica Lee',
                date: 'July 8th, 2023',
                rating: 4.6,
                content: 'Reliable, powerful, and stylish! The Tacoma is everything I wanted in a midsize truck.',
            },
        ]
    },
    {
        id: 17,
        dealerId: 5,
        image: images.car17Gallery1,
        price: 45,
        condition: 'Old',
        content: 'The GMC Sierra 1500 is a premium full-size pickup truck that blends power, technology, and luxury. With its advanced towing capabilities, refined interior, and rugged durability, it’s built to handle any job with style and strength.',
        gallery: {
            image1: images.car17Gallery1,
            image2: images.car17Gallery2,
            image3: images.car17Gallery3,
            image4: images.car17Gallery4,
        },
        details: {
            year: 2024,
            carMake: 'GMC',
            carModel: 'Sierra 1500',
            carType: 'Truck',
            passengers: '5 people',
            fuelType: 'Petrol / Diesel',
            mileage: '20 MPG (City)',
            engine: '5.3L V8',
            transmission: '10-Speed Automatic',
            horsepower: '355 HP',
            topSpeed: '120 mph',
            drivetrain: 'Rear-Wheel / 4WD',
        },
        description: 'The GMC Sierra 1500 is engineered for both toughness and comfort, making it a standout among full-size trucks. With a powerful V8 engine, cutting-edge towing technology, and a refined interior, it’s ready for any task. Whether you’re hauling heavy loads or cruising in luxury, the Sierra 1500 delivers top-tier performance.',
        features: {
            performance: [
                '5.3L V8 Engine',
                'Available 6.2L V8 or Turbo-Diesel Option',
                'Dynamic Fuel Management System',
                'Off-Road Suspension Package',
                'Max Trailering Package',
            ],
            comfort: [
                'Premium Leather Seating',
                'Heated & Ventilated Front Seats',
                'Dual-Zone Climate Control',
                'Power Sliding Rear Window',
                'Bose Premium Audio System',
            ],
            technology: [
                '13.4-inch Touchscreen Infotainment System',
                'Apple CarPlay & Android Auto',
                'Head-Up Display',
                'Wireless Charging Pad',
                'Navigation System',
            ],
            safety: [
                'GMC Pro Safety Suite',
                'Adaptive Cruise Control',
                'Lane Keep Assist with Lane Departure Warning',
                'Rear Cross-Traffic Alert',
                'Forward Collision Warning',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car17Review1,
                name: 'David Carter',
                date: 'April 22nd, 2023',
                rating: 4.9,
                content: 'The Sierra 1500 is a beast! The towing capacity is incredible, and the interior feels like a luxury SUV.',
            },
            {
                id: 2,
                image: images.car17Review2,
                name: 'Sophia Martinez',
                date: 'August 15th, 2023',
                rating: 4.7,
                content: 'Super smooth ride with tons of power! I love the high-tech features and premium interior materials.',
            },
        ]
    },
    {
        id: 18,
        dealerId: 6,
        image: images.car18Gallery1,
        price: 50,
        condition: 'Certified Pre-Owned',
        content: 'The BMW 3 Series is a luxury sports sedan that blends performance, elegance, and cutting-edge technology. With its precision handling, powerful engine options, and premium interior, it delivers an exhilarating driving experience.',
        gallery: {
            image1: images.car18Gallery1,
            image2: images.car18Gallery2,
            image3: images.car18Gallery3,
            image4: images.car18Gallery4,
        },
        details: {
            year: 2025,
            carMake: 'BMW',
            carModel: '3 Series',
            carType: 'Sedan',
            passengers: '5 people',
            fuelType: 'Petrol / Hybrid',
            mileage: '28 MPG (City)',
            engine: '2.0L Turbocharged Inline-4',
            transmission: '8-Speed Automatic',
            horsepower: '255 HP',
            topSpeed: '155 mph',
            drivetrain: 'Rear-Wheel / All-Wheel Drive',
        },
        description: 'The BMW 3 Series sets the standard for the ultimate driving experience, offering a dynamic balance of power, agility, and luxury. With a sleek aerodynamic design, intuitive technology, and a driver-centric cockpit, this sedan is engineered to thrill. Whether cruising through city streets or tackling winding roads, the 3 Series delivers an unmatched ride.',
        features: {
            performance: [
                '2.0L TwinPower Turbo Engine',
                'Available M340i with 382 HP',
                'Adaptive M Suspension',
                'Driving Modes (Eco, Comfort, Sport)',
                'Near 50/50 Weight Distribution',
            ],
            comfort: [
                'Vernasca Leather Upholstery',
                'Heated & Ventilated Seats',
                'Panoramic Sunroof',
                'Three-Zone Climate Control',
                'Harman Kardon Surround Sound System',
            ],
            technology: [
                'Live Cockpit Professional with 12.3-inch Display',
                'Apple CarPlay & Android Auto',
                'iDrive 8.0 with Gesture Control',
                'Heads-Up Display',
                'Wireless Charging & WiFi Hotspot',
            ],
            safety: [
                'BMW Driving Assistant Professional',
                'Lane Departure Warning',
                'Blind Spot Monitoring',
                'Rear Cross-Traffic Alert',
                '360-Degree Parking Cameras',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car18Review1,
                name: 'Liam Anderson',
                date: 'March 10th, 2023',
                rating: 4.8,
                content: 'The BMW 3 Series is everything I wanted—sporty, luxurious, and packed with technology. An absolute joy to drive!',
            },
            {
                id: 2,
                image: images.car18Review2,
                name: 'Emma Roberts',
                date: 'July 5th, 2023',
                rating: 4.6,
                content: 'Superb handling and a smooth ride! The interior is top-notch, and the technology makes every drive a breeze.',
            },
        ]
    },
    {
        id: 19,
        dealerId: 1,
        image: images.car19Gallery1,
        price: 45,
        condition: 'New',
        content: 'The Chevrolet Camaro Convertible is a bold and powerful muscle car that delivers an exhilarating open-top driving experience. With aggressive styling, thrilling performance, and advanced technology, it offers the perfect blend of power and style.',
        gallery: {
            image1: images.car19Gallery1,
            image2: images.car19Gallery2,
            image3: images.car19Gallery3,
            image4: images.car19Gallery4,
        },
        details: {
            year: 2021,
            carMake: 'Chevrolet',
            carModel: 'Camaro',
            carType: 'Convertible',
            passengers: '4 people',
            fuelType: 'Petrol',
            mileage: '22 MPG (City)',
            engine: '3.6L V6 / 6.2L V8',
            transmission: '6-Speed Manual / 10-Speed Automatic',
            horsepower: '335 - 650 HP',
            topSpeed: '165 mph',
            drivetrain: 'Rear-Wheel Drive',
        },
        description: 'The Chevrolet Camaro Convertible is designed for those who crave open-road excitement. With a high-performance powertrain, a striking exterior, and a driver-focused interior, the Camaro delivers raw power and unmatched style. Whether cruising down the highway or tearing up the track, this muscle car makes every drive unforgettable.',
        features: {
            performance: [
                'Available 6.2L Supercharged V8',
                'Magnetic Ride Control Suspension',
                'Brembo Performance Brakes',
                'Dual-Mode Performance Exhaust',
                'Launch Control & Line Lock',
            ],
            comfort: [
                'Leather-Trimmed Sport Seats',
                'Heated & Ventilated Front Seats',
                'Power-Operated Convertible Top',
                'Dual-Zone Automatic Climate Control',
                'Flat-Bottom Steering Wheel',
            ],
            technology: [
                'Chevrolet Infotainment 3 System',
                '8-inch Touchscreen with Navigation',
                'Apple CarPlay & Android Auto',
                'Bose Premium Audio System',
                'Head-Up Display',
            ],
            safety: [
                'Forward Collision Alert',
                'Rear Park Assist',
                'Lane Change Alert with Side Blind Zone Alert',
                'Rear Cross-Traffic Alert',
                'HD Rear Vision Camera',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car19Review1,
                name: 'Jake Mitchell',
                date: 'April 15th, 2023',
                rating: 4.9,
                content: 'The Camaro Convertible is an absolute beast! The V8 roar is addictive, and the drop-top makes every drive thrilling.',
            },
            {
                id: 2,
                image: images.car19Review2,
                name: 'Sophia Carter',
                date: 'August 22nd, 2023',
                rating: 4.7,
                content: 'Love the aggressive styling and raw power. The convertible experience is unbeatable on a sunny day!',
            },
        ]
    },
    {
        id: 20,
        dealerId: 2,
        image: images.car20Gallery1,
        price: 35,
        condition: 'Old',
        content: 'The Toyota RAV4 is a versatile and stylish SUV that blends efficiency, comfort, and capability. With its rugged design, spacious interior, and advanced technology, the RAV4 is perfect for both city commutes and outdoor adventures.',
        gallery: {
            image1: images.car20Gallery1,
            image2: images.car20Gallery2,
            image3: images.car20Gallery3,
            image4: images.car20Gallery4,
        },
        details: {
            year: 2022,
            carMake: 'Toyota',
            carModel: 'RAV4',
            carType: 'SUV',
            passengers: '5 people',
            fuelType: 'Petrol / Hybrid',
            mileage: '27-41 MPG (City)',
            engine: '2.5L 4-Cylinder',
            transmission: '8-Speed Automatic / CVT (Hybrid)',
            horsepower: '203 - 219 HP',
            topSpeed: '120 mph',
            drivetrain: 'Front-Wheel / All-Wheel Drive',
        },
        description: 'The Toyota RAV4 is engineered for those who seek adventure without compromising comfort. With impressive fuel efficiency, ample cargo space, and available all-wheel drive, this SUV is built for both urban and off-road exploration. The RAV4’s bold styling and innovative safety features make it a top choice for modern drivers.',
        features: {
            performance: [
                'Available All-Wheel Drive',
                'Multi-Terrain Select System',
                'Dynamic Torque Vectoring AWD',
                'Sport-Tuned Suspension',
                'Electronic Parking Brake',
            ],
            comfort: [
                'Spacious Interior with Fold-Flat Rear Seats',
                'Heated & Ventilated Front Seats',
                'Power-Adjustable Driver’s Seat',
                'Dual-Zone Climate Control',
                'Panoramic Sunroof',
            ],
            technology: [
                'Toyota Audio Multimedia System',
                '9-inch Touchscreen with Navigation',
                'Apple CarPlay & Android Auto',
                'JBL Premium Sound System',
                'Wireless Charging Pad',
            ],
            safety: [
                'Toyota Safety Sense 2.5+',
                'Adaptive Cruise Control',
                'Lane Departure Alert with Steering Assist',
                'Blind Spot Monitor with Rear Cross-Traffic Alert',
                '360-Degree Camera System',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car20Review1,
                name: 'Michael Johnson',
                date: 'March 10th, 2023',
                rating: 4.8,
                content: 'The RAV4 is an outstanding SUV! Great fuel economy, smooth ride, and perfect for road trips.',
            },
            {
                id: 2,
                image: images.car20Review2,
                name: 'Emily Sanders',
                date: 'July 2nd, 2023',
                rating: 4.6,
                content: 'Love the practicality and comfort of this SUV. Handles well in all weather conditions and has plenty of space!',
            },
        ]
    },
    {
        id: 21,
        dealerId: 3,
        image: images.car21Gallery1,
        price: 28,
        condition: 'Certified Pre-Owned',
        content: 'The Ford Focus Hatchback is a dynamic and fuel-efficient compact car that combines practicality with sporty appeal. With its sharp handling, modern technology, and spacious cargo area, it is perfect for both city driving and weekend getaways.',
        gallery: {
            image1: images.car21Gallery1,
            image2: images.car21Gallery2,
            image3: images.car21Gallery3,
            image4: images.car21Gallery4,
        },
        details: {
            year: 2023,
            carMake: 'Ford',
            carModel: 'Focus Hatchback',
            carType: 'Hatchback',
            passengers: '5 people',
            fuelType: 'Petrol / Diesel',
            mileage: '30-40 MPG (City)',
            engine: '1.5L EcoBoost 3-Cylinder',
            transmission: '6-Speed Manual / 8-Speed Automatic',
            horsepower: '181 HP',
            topSpeed: '130 mph',
            drivetrain: 'Front-Wheel Drive',
        },
        description: 'The Ford Focus Hatchback offers a refined balance between performance and efficiency, making it an excellent choice for urban commuters and driving enthusiasts alike. Its compact size makes it easy to maneuver, while the advanced driver-assist features ensure a safe and comfortable ride.',
        features: {
            performance: [
                '1.5L EcoBoost Engine',
                'Sport-Tuned Suspension',
                'Selectable Drive Modes',
                'Electronic Stability Control',
                'Auto Start-Stop Technology',
            ],
            comfort: [
                'Spacious Cabin with Premium Materials',
                'Adjustable Front Seats with Lumbar Support',
                'Dual-Zone Climate Control',
                'Panoramic Sunroof',
                'Fold-Flat Rear Seats for Extra Cargo Space',
            ],
            technology: [
                'SYNC 4 Infotainment System',
                '8-inch Touchscreen Display',
                'Apple CarPlay & Android Auto',
                'Premium Sound System',
                'Wireless Charging Pad',
            ],
            safety: [
                'Ford Co-Pilot360 Safety Suite',
                'Adaptive Cruise Control',
                'Lane-Keeping Assist',
                'Blind Spot Monitoring',
                'Rear Parking Sensors & Backup Camera',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car21Review1,
                name: 'David Williams',
                date: 'April 22nd, 2023',
                rating: 4.7,
                content: 'The Focus Hatchback is a fun and practical car! Great fuel economy, responsive handling, and a stylish design.',
            },
            {
                id: 2,
                image: images.car21Review2,
                name: 'Jessica Carter',
                date: 'August 15th, 2023',
                rating: 4.5,
                content: 'Absolutely love the tech features and smooth drive. It’s the perfect daily driver with plenty of space for my needs.',
            },
        ]
    },
    {
        id: 22,
        dealerId: 4,
        image: images.car22Gallery1,
        price: 70,
        condition: 'New',
        content: 'The Porsche 718 Cayman is a precision-engineered sports coupe designed for pure driving excitement. With its mid-engine layout, sharp handling, and striking design, it delivers an exhilarating experience on both the track and the open road.',
        gallery: {
            image1: images.car22Gallery1,
            image2: images.car22Gallery2,
            image3: images.car22Gallery3,
            image4: images.car22Gallery4,
        },
        details: {
            year: 2024,
            carMake: 'Porsche',
            carModel: '718 Cayman',
            carType: 'Sports Car',
            passengers: '2 people',
            fuelType: 'Petrol',
            mileage: '21 MPG (City)',
            engine: '2.0L Turbocharged Flat-4',
            transmission: '6-Speed Manual / 7-Speed PDK Automatic',
            horsepower: '300 HP',
            topSpeed: '170 mph',
            drivetrain: 'Rear-Wheel Drive',
        },
        description: 'The Porsche 718 Cayman redefines the driving experience with its lightweight chassis, perfectly balanced mid-engine setup, and race-inspired dynamics. Whether carving through winding roads or accelerating on the highway, the Cayman offers an unmatched blend of performance, precision, and luxury.',
        features: {
            performance: [
                '300 Horsepower Turbocharged Engine',
                'Porsche Active Suspension Management',
                'Rear-Wheel Drive with Sport Tuning',
                'Launch Control & Sport Chrono Package',
                'Electromechanical Power Steering',
            ],
            comfort: [
                'Premium Leather Sport Seats',
                'Dual-Zone Automatic Climate Control',
                'Electric Adjustable Seating with Memory',
                'Porsche Communication Management (PCM)',
                'Compact yet Spacious Interior',
            ],
            technology: [
                '7-inch Touchscreen Infotainment',
                'Apple CarPlay & Android Auto',
                'Premium Bose or Burmester Audio System',
                'Wireless Charging & Smart Connectivity',
                'Digital Instrument Cluster with Custom Modes',
            ],
            safety: [
                'Porsche Stability Management (PSM)',
                'Adaptive Cruise Control',
                'Lane Departure Warning',
                'Rearview Camera & Parking Sensors',
                'Advanced Airbag System',
            ],
        },
        comments: [
            {
                id: 1,
                image: images.car22Review1,
                name: 'James Hamilton',
                date: 'March 10th, 2023',
                rating: 4.9,
                content: 'Absolutely love my 718 Cayman! The handling is razor-sharp, and the power delivery is smooth and exhilarating.',
            },
            {
                id: 2,
                image: images.car22Review2,
                name: 'Sophia Bennett',
                date: 'July 22nd, 2023',
                rating: 4.8,
                content: 'A dream to drive! The mid-engine balance and the interior luxury make every trip special.',
            },
        ]
    },

];

export default cars;